import { render, staticRenderFns } from "./TrainingCourse.vue?vue&type=template&id=56ab89f5"
import script from "./TrainingCourse.vue?vue&type=script&lang=js"
export * from "./TrainingCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports